import React from "react";

type LeftArrowIconProps = React.SVGProps<SVGSVGElement>;

const LeftArrowIcon: React.FC<LeftArrowIconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 12.7497L5.00002 12.75C4.58581 12.75 4.25002 12.4142 4.25001 12C4.25001 11.5858 4.58579 11.25 5 11.25L20 11.2497C20.4142 11.2497 20.75 11.5855 20.75 11.9997C20.75 12.4139 20.4143 12.7497 20 12.7497Z"
      fill="#40599B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.53025 6.46967C9.82315 6.76256 9.82315 7.23744 9.53025 7.53033L5.23736 11.8232C5.1673 11.8933 5.11054 11.9501 5.06222 12C5.11054 12.0499 5.1673 12.1067 5.23736 12.1768L9.53025 16.4697C9.82315 16.7626 9.82315 17.2374 9.53025 17.5303C9.23736 17.8232 8.76249 17.8232 8.46959 17.5303L4.1767 13.2374C4.16862 13.2294 4.1605 13.2212 4.15234 13.2131C4.00724 13.0681 3.85035 12.9113 3.73577 12.7612C3.60153 12.5852 3.45703 12.3335 3.45703 12C3.45703 11.6665 3.60153 11.4148 3.73576 11.2388C3.85035 11.0887 4.00724 10.9319 4.15234 10.7869C4.1605 10.7788 4.16862 10.7706 4.1767 10.7626L8.46959 6.46967C8.76249 6.17678 9.23736 6.17678 9.53025 6.46967Z"
      fill="#40599B"
    />
  </svg>
);

export default LeftArrowIcon;
